<template>
<!--  司机出勤率报表-->
  <div class="week-template common-page">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="日期范围:">
              <custom-date-range
                :start-date="searchForm.startTime"
                :end-date="searchForm.endTime"
                @update:startDate="(val) => (searchForm.startTime = val)"
                @update:endDate="(val) => (searchForm.endTime = val)"></custom-date-range>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="companyType === '1'">
            <el-form-item label="分公司:">
              <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                <el-option
                  v-for="item in belongCompanyData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="服务商:">
              <el-select style="width: 100%" clearable v-model="searchForm.companyId" placeholder="请选择">
                <el-option
                  v-for="item in supplierData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="司机:">
              <el-input style="width: 100%" clearable v-model="searchForm.driver" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
              <el-button type="primary" :loading="downloadLoading" @click="handleDownload(`司机出勤率报表${searchForm.startTime}-${searchForm.endTime}.xlsx`)">导出</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :show-index="true"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:driverType="{ row }">
          <div v-if="row.driverType === 1">
            全职司机
          </div>
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import {  downloadExcel, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import CustomDateRange from "@/components/CustomDateRange.vue";
import dayjs from "dayjs";
import weekday from 'dayjs/plugin/weekday'
import { getSelectSupplier } from "@/views/SystemManagement/ServiceManagement/api";
dayjs.extend(weekday)
export default {
  name: "DriverAttendanceRate",
  mixins: [tableMixin],
  components: {
    CustomDateRange,
    OperateBox,
    CustomTable,
  },
  data() {
    return {
      supplierData: [],
      getTableMethod: getPage,
      downloadFileMethod: downloadExcel,
      haveBelongCompany: true,
      searchForm: {
        startTime: "",
        driver: "",
        endTime: "",
        belongCompanyId: "",
        companyId: "",
      },
      tableColumn: [
        {
          label: "服务商",
          prop: "companyName",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "driverName",
          show: true,
        },
        {
          label: "身份证号",
          prop: "idNo",
          show: true,
        },
        {
          label: "联系电话",
          prop: "phone",
          show: true,
        },
        {
          label: "入职时间",
          prop: "joinTime",
          show: true,
        },
        {
          label: "司机类型",
          prop: "driverType",
          scopeStatus: true,
          show: true,
        },
        {
          label: "个人排班总次数",
          prop: "schedulingTimes",
          show: true,
        },
        {
          label: "个人实际出勤车次",
          prop: "attendanceTimes",
          show: true,
        },
        {
          label: "个人出勤率",
          prop: "attendanceRate",
          show: true,
        },
        {
          label: "个人缺勤车次",
          prop: "absenceTimes",
          show: true,
        },
      ],
      isImmediatelyGetData: true,
    };
  },
  watch: {
    "searchForm.belongCompanyId":function(val) {
      this.searchForm.companyId = ""
      this.getSelectSupplierData(val)
    }
  },
  mounted() {
    // this.getSelectSupplierData()
  },
  methods: {
    getSelectSupplierData(val) {
      getSelectSupplier({belongCompanyId: val, keyword: ''}).then(response => {
        if (response.code === 200) {
          this.supplierData = response.data
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.week-template {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-form-box {
    flex-shrink: 0;
  }
  .custom-table-box{
    padding-top: 0;
    padding-left: 0;
    flex: 1;
  }
}
</style>
